var _defs, _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgPricing(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 608.19,
    height: 361.205,
    viewBox: "0 0 608.19 361.205",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_122",
    "data-name": "Rectangle 122",
    width: 374.693,
    height: 240.448,
    fill: "none"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "pricing",
    transform: "translate(-222.517 -281.934)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_1483",
    "data-name": "Group 1483",
    transform: "translate(222.066 390.018) rotate(-43)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_333",
    "data-name": "Path 333",
    d: "M111.912,150.375l-78.872,16.3L9.876,61.251v0L.115,16.831,78.984.538,97.21,83.473Z",
    fill: "rgba(255,114,94,0.39)"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_1447",
    "data-name": "Group 1447",
    transform: "translate(10.295 8.535)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_334",
    "data-name": "Path 334",
    d: "M90.916,135.095l-61.232,12.65L.089,13.067,61.321.418Zm-54.13,9.227,46.178-9.54a5.723,5.723,0,0,0,4.425-6.863L61.139,8.466a6.006,6.006,0,0,0-7.05-4.6L8.1,13.369A5.778,5.778,0,0,0,3.628,20.3L29.895,139.827A5.87,5.87,0,0,0,36.786,144.322Z",
    fill: "#ff725e"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Path_428",
    "data-name": "Path 428",
    d: "M16.756.008A16.874,16.874,0,0,1,33.509,16.992,16.86,16.86,0,0,1,16.762,33.969,16.874,16.874,0,0,1,.008,16.986,16.86,16.86,0,0,1,16.756.008Z",
    transform: "translate(31.933 82.454) rotate(-45)",
    fill: "#ff725e"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_438",
    "data-name": "Path 438",
    d: "M111.912,150.375l-78.872,16.3L9.876,61.251v0L.115,16.831,78.984.538,97.21,83.473Z",
    fill: "rgba(255,114,94,0.39)"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_1448",
    "data-name": "Group 1448",
    transform: "translate(349.907 281.934)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_333-2",
    "data-name": "Path 333",
    d: "M958.63,430.6l-79.488,16.726-22.59-104.6v0l-9.518-44.071,79.486-16.724,17.773,82.288Z",
    transform: "translate(-847.034 -281.934)",
    fill: "rgba(255,114,94,0.39)"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_1447-2",
    "data-name": "Group 1447",
    transform: "translate(10.302 8.412)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_334-2",
    "data-name": "Path 334",
    d: "M976.3,447.571l-61.711,12.985-28.86-133.626,61.711-12.984Zm-54.54,9.535,46.539-9.792a5.773,5.773,0,0,0,4.5-6.849L947.2,321.944a5.953,5.953,0,0,0-7.064-4.522l-46.353,9.753a5.828,5.828,0,0,0-4.543,6.914l25.614,118.6A5.819,5.819,0,0,0,921.762,457.107Z",
    transform: "translate(-885.731 -313.945)",
    fill: "#ff725e"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Path_428-2",
    "data-name": "Path 428",
    d: "M16.871.115A17.134,17.134,0,0,1,33.847,17.091,16.6,16.6,0,0,1,17.091,33.847,17.134,17.134,0,0,1,.115,16.871,16.6,16.6,0,0,1,16.871.115Z",
    transform: "translate(31.572 81.717) rotate(-45)",
    fill: "#ff725e"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_438-2",
    "data-name": "Path 438",
    d: "M958.63,430.6l-79.488,16.726-22.59-104.6v0l-9.518-44.071,79.486-16.724,17.773,82.288Z",
    transform: "translate(-847.034 -281.934)",
    fill: "rgba(255,114,94,0.39)"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Path_842",
    "data-name": "Path 842",
    d: "M27.755,0H356.578c32.262,0,31.283,26.153,31.283,58.415V235.6a15.475,15.475,0,0,1-15.475,15.475H15.475A15.475,15.475,0,0,1,0,235.6V38.718C0,17.335,6.372,0,27.755,0Z",
    transform: "translate(330.504 388.613)",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_114",
    "data-name": "Rectangle 114",
    width: 368.641,
    height: 236.654,
    rx: 21.614,
    transform: "translate(339.201 397.329)",
    fill: "#ff725e"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_115",
    "data-name": "Rectangle 115",
    width: 69.578,
    height: 5.76,
    transform: "translate(347.845 405.235)",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_116",
    "data-name": "Rectangle 116",
    width: 57.86,
    height: 2.88,
    transform: "translate(347.845 419.838)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_117",
    "data-name": "Rectangle 117",
    width: 30.59,
    height: 2.88,
    transform: "translate(347.845 427.638)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_118",
    "data-name": "Rectangle 118",
    width: 38.87,
    height: 2.88,
    transform: "translate(347.845 435.438)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_119",
    "data-name": "Rectangle 119",
    width: 10.557,
    height: 2.88,
    transform: "translate(391.721 435.438)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_120",
    "data-name": "Rectangle 120",
    width: 19.947,
    height: 2.88,
    transform: "translate(405.878 435.438)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_121",
    "data-name": "Rectangle 121",
    width: 30.59,
    height: 2.88,
    transform: "translate(380.566 427.638)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_1451",
    "data-name": "Group 1451",
    transform: "translate(346.317 393.535)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_1450",
    "data-name": "Group 1450",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_1449",
    "data-name": "Group 1449",
    transform: "translate(199.161 21.758)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_335",
    "data-name": "Path 335",
    d: "M1599.494,1159.846s-3.413-4.088-5.248-4.661-5.387-3.287-5.85-2.169,2.387,2.842,2.237,4.12-9.062,3.329-9.007,4.682a5.247,5.247,0,0,0,5.5,4.246c3.4-.375,12.019-2.394,13.789-1.522S1599.494,1159.846,1599.494,1159.846Z",
    transform: "translate(-1581.626 -1057.279)",
    fill: "#ffb27d"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_336",
    "data-name": "Path 336",
    d: "M1736.421,1029.948a72.5,72.5,0,0,1-16.975,16.095,94.583,94.583,0,0,1-40.109,15.179c-5-1.58-20.365-3.23-29.444-4.674h0c-3.958-.628-6.719-1.219-6.906-1.743l.228-7.806s33.323-1.739,38.84-4.265a123.916,123.916,0,0,0,21.4-24.512c4.231-6.34,8.967-11.022,16.774-13.769C1731.514,1000.48,1752.043,1009.234,1736.421,1029.948Z",
    transform: "translate(-1626.649 -947.263)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_337",
    "data-name": "Path 337",
    d: "M1740.187,1131.56l-1.7,4.911a94.584,94.584,0,0,1-40.109,15.179c-4.018,0-20.365-3.231-29.444-4.674.359.029,24.719,1.909,30.1,1.359,5.424-.554,30.674-22.153,30.674-22.153Z",
    transform: "translate(-1645.691 -1037.692)",
    fill: "#dfebfd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_338",
    "data-name": "Path 338",
    d: "M1854.852,2031.963h36.825c2.638-1.766-.712-19.033-.712-19.033s-10.051-3.764-11.786,3.891-12.8,10.081-18.655,11.014C1856.518,2028.478,1855.253,2030.65,1854.852,2031.963Z",
    transform: "translate(-1782.111 -1690.743)",
    fill: "#233862"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_339",
    "data-name": "Path 339",
    d: "M2060,2031.963h36.825c2.639-1.766-.712-19.033-.712-19.033s-10.051-3.764-11.786,3.891-12.8,10.081-18.655,11.014C2061.661,2028.478,2060.4,2030.65,2060,2031.963Z",
    transform: "translate(-1932.638 -1690.743)",
    fill: "#233862"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_340",
    "data-name": "Path 340",
    d: "M1892.067,1409.706s1.655,20.383,3.6,44.885c2.644,33.283,9.776,115.8,9.776,115.8s4.675,3.937,15.032,1.783a319.336,319.336,0,0,0,11.451-60.961c.041-.533.082-1.069.123-1.606,2.452-33.077,6.265-102.73,6.265-102.73Z",
    transform: "translate(-1809.418 -1244.632)",
    fill: "#2b478b"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_341",
    "data-name": "Path 341",
    d: "M1889.945,1390.824s2.22,27.426,4.166,51.928l36.259,56.627c.041-.532.082-1.069.122-1.606,2.452-33.077,6.265-102.73,6.265-102.73Z",
    transform: "translate(-1807.861 -1232.794)",
    fill: "#233862"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_342",
    "data-name": "Path 342",
    d: "M1929.641,1355.8s26.3,64.61,34.7,89.1c5.988,17.445,22.876,78.645,22.876,78.645s7.344,2.206,13.516-2.058c0,0,6.283-62.526-6.409-80.156-6.733-9.353-1.673-97.232-28.974-97.985S1929.641,1355.8,1929.641,1355.8Z",
    transform: "translate(-1836.989 -1197.769)",
    fill: "#2b478b"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_343",
    "data-name": "Path 343",
    d: "M1969.74,957.145a16.607,16.607,0,0,0,11.329,1.505,23.659,23.659,0,0,0,7.676-3.2,22.62,22.62,0,0,0,3.1-2.3s-.135-.194-.364-.575c-1.186-2-4.782-9.2-3.182-20.768.021-.152-1.139.063-2.893.472-5.218,1.22-15.708,4.156-16.173,4.287h-.018s-.128,2.432-.561,6.793c-.036.384-.075.786-.118,1.2-.054.511-.107,1.054-.172,1.611C1967.875,950.707,1969.74,957.145,1969.74,957.145Z",
    transform: "translate(-1865.341 -894.36)",
    fill: "#ffb27d"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_344",
    "data-name": "Path 344",
    d: "M1969.67,944.823c7.79,1.763,19.416-9.589,19.416-9.589a12.334,12.334,0,0,0-2.664-1.491c-5.219,1.219-15.708,4.156-16.173,4.287h-.018S1970.1,940.462,1969.67,944.823Z",
    transform: "translate(-1866.361 -895.822)",
    fill: "#ed975d"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_345",
    "data-name": "Path 345",
    d: "M1953.779,859.15a40.057,40.057,0,0,0,7.287,1.677c5.972.8,13.825.327,16.292-6.805,4.155-12,9.463-19.2-2.765-24.1-6.546-2.624-10.733-2.764-13.577-1.762a9.8,9.8,0,0,0-5.031,4.3C1953.61,836.129,1948.833,857.048,1953.779,859.15Z",
    transform: "translate(-1853.116 -817.557)",
    fill: "#ffb27d"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_346",
    "data-name": "Path 346",
    d: "M1931.86,805.281c7.081,5.023,16.875.085,19.919,1.422s3.587,6.368,3.642,7.966.268,2.951,4.4,1.993a2.033,2.033,0,0,1,1.5.089c1.713,1-.476,5.866-1.137,6.918,0,0-.95,3.483,1.159,5.179.255.2,4.4,1.99,14.381-13.089a13.845,13.845,0,0,0,.644-12.833c-2.42-5.134-12.538-10.1-21.117-12.726-3.215-.986-5.6-.95-7.464-.275-3.111,1.122-4.769,4.024-6.415,6.938C1938.609,801.758,1931.86,805.281,1931.86,805.281Z",
    transform: "translate(-1838.617 -789.435)",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_347",
    "data-name": "Path 347",
    d: "M1936.162,1100.237s-3.427.731-7.759,1.455a86.036,86.036,0,0,1-12.958,1.366,118.228,118.228,0,0,1-33.917-5.509c-3.471,0-5.058-5.306-5.626-12.708a143.97,143.97,0,0,1-.026-16.936c.09-1.927.2-3.855.322-5.742.243-3.744.528-7.337.786-10.516.243-2.983.464-5.6.595-7.625,0,0-.494-14.186-.3-26.665.139-8.957,5.229-17.11,6.505-18.439,3.7-3.858,14.406-6.3,16.549-6.635.165-.022.251-.037.251-.037,8.806,4.881,20.664-1.713,20.664-1.713.269.044.531.107.793.162.871-.185,9.771,1.119,11.843,2.234,5.121,2.754,8.095,33.319,8.095,33.319.853,20.761-.22,54.01,1.444,66.7C1943.972,1097.128,1939.872,1099.391,1936.162,1100.237Z",
    transform: "translate(-1797.364 -937.689)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_348",
    "data-name": "Path 348",
    d: "M1987.208,991.2s-13.121,13.357-22.5,10.621c0,0-1.25-1.8,2.975-2.382S1976.466,999.1,1987.208,991.2Z",
    transform: "translate(-1862.592 -938.182)",
    fill: "#dfebfd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_349",
    "data-name": "Path 349",
    d: "M1959.371,918.223s-.256,1.554,3.4,2.794c0,0,3.073,1.042,3.634-.552A10.512,10.512,0,0,0,1959.371,918.223Z",
    transform: "translate(-1858.801 -884.38)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_350",
    "data-name": "Path 350",
    d: "M1929.174,1183.508s-19.056,31.458-29.867,37c-7.309,3.744-17.544,5.716-23.406,6.6a143.968,143.968,0,0,1-.026-16.936c7.743-.927,19.538-2.4,19.538-2.4Z",
    transform: "translate(-1797.364 -1079.955)",
    fill: "#dfebfd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_351",
    "data-name": "Path 351",
    d: "M1905.609,1123.359l-10.157,36.187s-11.952.746-17.72.539c.243-3.744.251-3.869.509-7.048C1878.241,1153.037,1891.962,1145.977,1905.609,1123.359Z",
    transform: "translate(-1798.9 -1035.612)",
    fill: "#dfebfd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_352",
    "data-name": "Path 352",
    d: "M1703.471,1251.351s-3.413-4.088-5.248-4.661-5.387-3.287-5.85-2.168,2.387,2.842,2.237,4.12-9.062,3.33-9.007,4.682a5.247,5.247,0,0,0,5.5,4.245c3.4-.375,12.019-2.394,13.789-1.522S1703.471,1251.351,1703.471,1251.351Z",
    transform: "translate(-1657.921 -1124.738)",
    fill: "#ffb27d"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_353",
    "data-name": "Path 353",
    d: "M1983.793,1016.526s.6,19.166-43.659,57.62l-8.889-15.714c-1.637-.941,28.593-65.115,37.281-64.6C1985.359,994.822,1983.793,1016.526,1983.793,1016.526Z",
    transform: "translate(-1838.118 -940.117)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_354",
    "data-name": "Path 354",
    d: "M1794.223,1232.556s-50.333,5.68-52.2,6.667-5.862,4.831-4.529,9.652c0,0,26.055,3.233,40.391,3.173a95.933,95.933,0,0,0,20.365-2.009Z",
    transform: "translate(-1695.803 -1116.115)",
    fill: "#fff"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "Group_1456",
    "data-name": "Group 1456",
    transform: "translate(454.388 346.604)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_355",
    "data-name": "Path 355",
    d: "M1384.042,598.951a70.5,70.5,0,0,1-16.394,45.68,59.238,59.238,0,0,0-13.908,37.858v19.945a22.712,22.712,0,0,1-5.537,14.842,23.407,23.407,0,0,1-17.785,8.173H1293.1a23.237,23.237,0,0,1-23.318-23.016V682.523a59,59,0,0,0-13.839-37.806,70.511,70.511,0,0,1-16.464-45.335c0-34.06,24.182-62.547,56.529-69.641q1.379-.306,2.779-.552c.5-.09.993-.173,1.493-.252a73.236,73.236,0,0,1,11.483-.9C1351.628,528.037,1383.807,559.6,1384.042,598.951Z",
    transform: "translate(-1239.479 -528.037)",
    fill: "#ffeddc"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_356",
    "data-name": "Path 356",
    d: "M1469.213,1279.3l-.081.613-1.025,7.758-.27,2.044v.017l-.274,2.057-1.021,7.755-.27,2.043,0,.018-.27,2.061-.151,1.136c-.519,3.934-5.077,6.94-10.527,6.94H1443.04a14.183,14.183,0,0,1-3.7-.481h0a12.009,12.009,0,0,1-2.86-1.174l-.067-.038a9.459,9.459,0,0,1-1.86-1.4,6.617,6.617,0,0,1-2.035-3.775l-.435-3.006-.277-1.894v0l0-.041v0l-.27-1.853-1.042-7.19-.274-1.887-.007-.042-.27-1.863-1.13-7.789Z",
    transform: "translate(-1378.405 -1081.885)",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_1452",
    "data-name": "Group 1452",
    transform: "translate(51.536 197.413)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_357",
    "data-name": "Path 357",
    d: "M1467.453,1279.3h-6.941c-11.2,3.2-22.31,6.355-27.457,7.789l.27,1.863.007.042.274,1.887c4.168-1.139,14.176-3.969,38.64-10.969l.081-.613Z",
    transform: "translate(-1433.055 -1279.299)",
    fill: "#233862"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_358",
    "data-name": "Path 358",
    d: "M1439.309,1323.408v0l0,.041v0l.277,1.894c4.821-1.337,14.765-4.153,35.479-10.078l.273-2.057v-.017l.27-2.044c-13.088,3.741-28.931,8.257-36.573,10.4Z",
    transform: "translate(-1437.446 -1302.783)",
    fill: "#233862"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_359",
    "data-name": "Path 359",
    d: "M1452.247,1366.84l.067.038a11.993,11.993,0,0,0,2.86,1.174h0c5.681-1.607,14.113-4.011,26.654-7.595l.27-2.061,0-.018.27-2.043c-11.2,3.2-24.05,6.865-31.987,9.105A9.473,9.473,0,0,0,1452.247,1366.84Z",
    transform: "translate(-1445.773 -1336.092)",
    fill: "#233862"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_1453",
    "data-name": "Group 1453",
    transform: "translate(42.036 105.869)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_431",
    "data-name": "Path 431",
    d: "M.009,0,3.277.007l.2,92.61L.21,92.61Z",
    transform: "translate(0 0.54) rotate(-9.615)",
    fill: "#f99746"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_1454",
    "data-name": "Group 1454",
    transform: "translate(82.172 107.287)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_432",
    "data-name": "Path 432",
    d: "M0,.01,91.367.223l.008,3.268L.008,3.278Z",
    transform: "translate(0 89.835) rotate(-79.632)",
    fill: "#f99746"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_1455",
    "data-name": "Group 1455",
    transform: "translate(43.63 104.349)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_360",
    "data-name": "Path 360",
    d: "M1440.639,943.485a6.464,6.464,0,0,1-1.412-.17,2.012,2.012,0,0,1-1.6-1.73c-.373-2.016,1.23-5.716,3.481-8.85-1.176-2.027-2.743-3.7-4.386-4.19-2.427-.727-6.151,1.485-8.745,4.311a19.1,19.1,0,0,1,1.276,2.051c1.329,2.476,2.283,5.644.977,7.107-.484.543-1.473,1.035-3.434.3-2.45-.912-3.33-2.96-2.416-5.619a12.891,12.891,0,0,1,2.322-3.916c-2.008-2.586-4.693-4.551-7.338-4.222a8.167,8.167,0,0,0-3.633,1.353c1.692,3.107,2.081,7.05.907,9.166a2.965,2.965,0,0,1-3.934,1.288c-1.247-.438-1.9-2.133-1.659-4.318a9.933,9.933,0,0,1,3.393-6.387,8.325,8.325,0,0,0-1.88-2.081,6.285,6.285,0,0,0-8.483.417l-.711-.68c.046-.046,4.555-4.53,9.8-.509a3.307,3.307,0,0,0,6.076.781c2.965-.368,5.924,1.7,8.12,4.445,2.823-3.027,6.842-5.263,9.647-4.427,1.772.529,3.444,2.217,4.721,4.3a16.872,16.872,0,0,1,3.8-3.693c2.065-1.35,3.411-1.04,4.173-.543a7.418,7.418,0,0,1,2.006,1.979,11.134,11.134,0,0,1,1.92-1.221c2.392-1.176,4.589-1.09,6.186.242l-.639.746c-1.722-1.438-3.939-.688-5.106-.114a10.319,10.319,0,0,0-1.84,1.175c1.592,2.835,1.9,6.529.989,8.318a2.1,2.1,0,0,1-2.8,1.084,3.676,3.676,0,0,1-2.751-3.346c-.118-2.094,1.353-4.479,3.275-6.236a6.435,6.435,0,0,0-1.784-1.811c-.934-.607-2.193-.04-3.084.542a16.587,16.587,0,0,0-3.826,3.794c1.484,2.787,2.253,6.035,1.691,8.129A3.189,3.189,0,0,1,1440.639,943.485Zm.98-9.793c-1.958,2.819-3.337,6.008-3.021,7.717a1.055,1.055,0,0,0,.847.953c1.939.434,3.13-.124,3.541-1.661C1443.462,938.927,1442.839,936.156,1441.619,933.692Zm-14.307-.071a11.553,11.553,0,0,0-2,3.392c-.751,2.183-.136,3.66,1.828,4.391.791.294,1.839.527,2.342-.036.777-.871.321-3.34-1.109-6A18.605,18.605,0,0,0,1427.313,933.621Zm-12.371-3.094a8.947,8.947,0,0,0-2.914,5.629c-.183,1.666.231,3.02,1.008,3.292a2.014,2.014,0,0,0,2.734-.837C1416.774,936.8,1416.408,933.312,1414.942,930.527Zm36.513.623c-1.719,1.63-2.887,3.719-2.8,5.328a2.762,2.762,0,0,0,2.1,2.484,1.123,1.123,0,0,0,1.575-.605C1453.1,936.857,1452.775,933.647,1451.455,931.15Z",
    transform: "translate(-1403.361 -925.138)",
    fill: "#f99746"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Path_361",
    "data-name": "Path 361",
    d: "M1586.731,612.284c5.942,5.525,5.2,15.693-2.447,17.955-5.763,1.706-14.356-.572-18.6-7.831s-2.288-13.227,2.922-16.2S1580.549,606.536,1586.731,612.284Z",
    transform: "translate(-1477.137 -584.849)",
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Rectangle_125",
    "data-name": "Rectangle 125",
    d: "M5.643,0H447.137a5.643,5.643,0,0,1,5.643,5.643v0a5.643,5.643,0,0,1-5.643,5.643H5.644A5.644,5.644,0,0,1,0,5.643v0A5.643,5.643,0,0,1,5.643,0Z",
    transform: "translate(295.624 628.34)",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_1457",
    "data-name": "Group 1457",
    transform: "translate(348.604 562.701)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_126",
    "data-name": "Rectangle 126",
    width: 80.65,
    height: 65.638,
    transform: "translate(98.783 65.638) rotate(180)",
    fill: "#efc8ab"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_127",
    "data-name": "Rectangle 127",
    width: 80.65,
    height: 65.638,
    transform: "translate(139.108 65.638) rotate(180)",
    fill: "#ffeddc"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_362",
    "data-name": "Path 362",
    d: "M1061.717,1350.4h80.858v20.87l-80.858,44.769Z",
    transform: "translate(-1003.26 -1350.401)",
    fill: "#f7dcc6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_363",
    "data-name": "Path 363",
    d: "M1061.717,1350.4l15.958,17.27h79.583l-14.891-17.27Z",
    transform: "translate(-1003.26 -1350.401)",
    fill: "#ffeddc"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_364",
    "data-name": "Path 364",
    d: "M950.705,1357.822l-17,16.78H910.427v-24.2h40.278Z",
    transform: "translate(-892.247 -1350.401)",
    fill: "#e8b795"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_365",
    "data-name": "Path 365",
    d: "M860.275,1350.4l-18.133,17.27h40.351L900.6,1350.4Z",
    transform: "translate(-842.142 -1350.401)",
    fill: "#ffeddc"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_1462",
    "data-name": "Group 1462",
    transform: "translate(752.647 565.959)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_1460",
    "data-name": "Group 1460",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_434",
    "data-name": "Path 434",
    d: "M34.664.061C53.895.177,69.582,15.668,69.7,34.66A34.1,34.1,0,0,1,35.1,68.839C15.868,68.723.181,53.232.061,34.24A34.1,34.1,0,0,1,34.664.061Z",
    transform: "translate(0 8.933) rotate(-7.47)",
    fill: "#e2810e"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_366",
    "data-name": "Path 366",
    d: "M2401.9,1447.646q.646.389,1.314.753c.151.082.3.163.453.241q.517.272,1.038.526a35.223,35.223,0,0,0,46.041-14.339,34.261,34.261,0,0,0-10.18-44.687,35.207,35.207,0,0,0-3.571-2.226q-.672-.366-1.355-.7c-.441-.217-.886-.424-1.333-.62a35.295,35.295,0,0,0-10.5-2.786,35.5,35.5,0,0,0-19.1,3.338,34.637,34.637,0,0,0-15.24,14.339A34.283,34.283,0,0,0,2401.9,1447.646Z",
    transform: "translate(-2378.37 -1378.147)",
    fill: "#ffb93e"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_1458",
    "data-name": "Group 1458",
    transform: "translate(10.194 9.43)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_367",
    "data-name": "Path 367",
    d: "M2429.363,1460.56a31.475,31.475,0,0,1-15.081-3.839,30.768,30.768,0,0,1-12.32-42.035,31.6,31.6,0,0,1,42.587-12.16,30.768,30.768,0,0,1,12.32,42.035h0A31.447,31.447,0,0,1,2429.363,1460.56Zm.1-61.039a30.6,30.6,0,0,0-26.765,15.568,29.939,29.939,0,0,0,11.987,40.9,30.749,30.749,0,0,0,41.439-11.832l.37.2-.37-.2a29.939,29.939,0,0,0-11.988-40.9A30.636,30.636,0,0,0,2429.467,1399.521Z",
    transform: "translate(-2398.072 -1398.686)",
    fill: "#ffa412"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_1459",
    "data-name": "Group 1459",
    transform: "translate(25.35 17.659)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_368",
    "data-name": "Path 368",
    d: "M2455,1459.569a8.564,8.564,0,0,0,.859,3.531c.04.084.082.166.125.248a10.684,10.684,0,0,0,2.208,2.846,15.943,15.943,0,0,0,3.66,2.521l-1.85,4.5,3.921,1.571,1.841-4.477a17.994,17.994,0,0,0,4.322.7,11.435,11.435,0,0,0,4.2-.6,10.138,10.138,0,0,0,3.692-2.274,12.136,12.136,0,0,0,2.8-4.3l-7.127-2.856a7.449,7.449,0,0,1-1.559,2.5,4.912,4.912,0,0,1-1.927,1.23,4.839,4.839,0,0,1-2.111.208,8.324,8.324,0,0,1-2.092-.536,6.847,6.847,0,0,1-1.914-1.109,4.5,4.5,0,0,1-1.132-1.4,3.521,3.521,0,0,1-.381-1.588,4.288,4.288,0,0,1,.341-1.667,5.167,5.167,0,0,1,.959-1.564,3.854,3.854,0,0,1,1.427-.956,7.34,7.34,0,0,1,2.037-.447,19.17,19.17,0,0,1,2.78-.018,50.882,50.882,0,0,0,5.111.006,16,16,0,0,0,4.247-.76,9.356,9.356,0,0,0,3.336-1.929,9.465,9.465,0,0,0,2.349-3.51,9.359,9.359,0,0,0,.751-3.781,8.661,8.661,0,0,0-.839-3.55,10.935,10.935,0,0,0-2.283-3.141,14.809,14.809,0,0,0-3.622-2.544l1.99-4.839-3.946-1.581-2.018,4.906a13.368,13.368,0,0,0-4.3-.434,10.377,10.377,0,0,0-3.828.994,10.227,10.227,0,0,0-3.159,2.408,13.116,13.116,0,0,0-2.333,3.819l7.128,2.856a6.42,6.42,0,0,1,2.889-3.569,4.556,4.556,0,0,1,3.822-.036,5.717,5.717,0,0,1,1.784,1.072,3.815,3.815,0,0,1,.976,1.365,3.52,3.52,0,0,1,.249,1.561,5.192,5.192,0,0,1-.4,1.659,4.812,4.812,0,0,1-.869,1.415,3.6,3.6,0,0,1-1.368.915,7.372,7.372,0,0,1-2.049.442,24.827,24.827,0,0,1-2.911.058q-2.754-.076-5.1.065a16.187,16.187,0,0,0-4.244.787,9.5,9.5,0,0,0-3.341,1.94,9.056,9.056,0,0,0-2.122,2.992c-.074.162-.148.326-.217.5A9.4,9.4,0,0,0,2455,1459.569Z",
    transform: "translate(-2455 -1430.002)",
    fill: "#ffa412"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "Group_1473",
    "data-name": "Group 1473",
    transform: "translate(312.858 471.646)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_1470",
    "data-name": "Group 1470",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_430",
    "data-name": "Path 430",
    d: "M26.666.081a26.7,26.7,0,0,1,26.74,26.43A26.323,26.323,0,0,1,26.82,52.786,26.7,26.7,0,0,1,.081,26.356,26.323,26.323,0,0,1,26.666.081Z",
    transform: "translate(0 12.079) rotate(-13.266)",
    fill: "#e2810e"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_404",
    "data-name": "Path 404",
    d: "M785.9,1067.447a26.157,26.157,0,0,0-10.486-35.775,26.864,26.864,0,0,0-36.245,10.349,26.158,26.158,0,0,0,10.485,35.775A26.865,26.865,0,0,0,785.9,1067.447Z",
    transform: "translate(-728.401 -1021.955)",
    fill: "#ffb93e"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_1468",
    "data-name": "Group 1468",
    transform: "translate(10.064 9.445)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_405",
    "data-name": "Path 405",
    d: "M769.553,1087.028a24,24,0,0,1-11.5-2.928,23.5,23.5,0,0,1-11.424-14.107,23.172,23.172,0,0,1,2.029-17.948,23.694,23.694,0,0,1,14.293-11.275,24.027,24.027,0,0,1,18.184,2,23.464,23.464,0,0,1,9.4,32.055A23.981,23.981,0,0,1,769.553,1087.028Zm.073-46.562a23.642,23.642,0,0,0-6.5.915,23.055,23.055,0,0,0-13.907,10.971,22.545,22.545,0,0,0-1.974,17.464,22.867,22.867,0,0,0,11.115,13.727,23.457,23.457,0,0,0,31.6-9.023,22.546,22.546,0,0,0,1.974-17.464,22.869,22.869,0,0,0-11.115-13.727A23.381,23.381,0,0,0,769.626,1040.467Z",
    transform: "translate(-745.676 -1039.83)",
    fill: "#ffa412"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_1469",
    "data-name": "Group 1469",
    transform: "translate(21.637 15.735)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_406",
    "data-name": "Path 406",
    d: "M806.683,1085.587a3.951,3.951,0,0,0-.732-1.193,2.934,2.934,0,0,0-1.088-.729,5.617,5.617,0,0,0-1.554-.342,14.816,14.816,0,0,0-2.119-.014,38.908,38.908,0,0,1-3.9.005,12.241,12.241,0,0,1-3.24-.58,7.139,7.139,0,0,1-2.544-1.471,7.23,7.23,0,0,1-1.791-2.677,7.139,7.139,0,0,1-.573-2.884,6.6,6.6,0,0,1,.639-2.706,8.332,8.332,0,0,1,1.742-2.4,11.253,11.253,0,0,1,2.762-1.94l-1.518-3.69,3.009-1.206,1.539,3.742a10.216,10.216,0,0,1,3.281-.331,7.917,7.917,0,0,1,2.919.758,7.809,7.809,0,0,1,2.409,1.837,10,10,0,0,1,1.779,2.912l-5.435,2.178a4.892,4.892,0,0,0-2.2-2.722,3.475,3.475,0,0,0-2.914-.027,4.39,4.39,0,0,0-1.362.817,2.916,2.916,0,0,0-.744,1.041,2.689,2.689,0,0,0-.189,1.191,3.95,3.95,0,0,0,.3,1.265,3.651,3.651,0,0,0,.663,1.08,2.752,2.752,0,0,0,1.043.7,5.612,5.612,0,0,0,1.563.337,19.019,19.019,0,0,0,2.22.045q2.1-.059,3.886.049a12.389,12.389,0,0,1,3.237.6,6.834,6.834,0,0,1,4.331,4.139,7.162,7.162,0,0,1,.585,2.938,6.517,6.517,0,0,1-.655,2.693,8.047,8.047,0,0,1-1.779,2.36,12.141,12.141,0,0,1-2.791,1.922l1.411,3.431-2.99,1.2-1.4-3.414a13.769,13.769,0,0,1-3.295.537,8.733,8.733,0,0,1-3.2-.455,7.736,7.736,0,0,1-2.816-1.734,9.264,9.264,0,0,1-2.138-3.28l5.435-2.178a5.716,5.716,0,0,0,1.188,1.9,3.756,3.756,0,0,0,1.47.937,3.681,3.681,0,0,0,1.61.158,6.288,6.288,0,0,0,1.6-.409,5.218,5.218,0,0,0,1.459-.846,3.437,3.437,0,0,0,.864-1.069,2.7,2.7,0,0,0,.29-1.211A3.28,3.28,0,0,0,806.683,1085.587Z",
    transform: "translate(-789.144 -1063.766)",
    fill: "#ffa412"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "Group_1476",
    "data-name": "Group 1476",
    transform: "translate(449.258 568.448)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_437",
    "data-name": "Path 437",
    d: "M29.307.011A29.617,29.617,0,0,1,58.676,29.765a29.437,29.437,0,0,1-29.3,29.679A29.617,29.617,0,0,1,.011,29.69,29.437,29.437,0,0,1,29.307.011Z",
    transform: "translate(2.789 58.836) rotate(-88.494)",
    fill: "#e2810e"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_435",
    "data-name": "Path 435",
    d: "M29.293.013A29.633,29.633,0,0,1,58.665,29.771a29.406,29.406,0,0,1-29.28,29.662A29.633,29.633,0,0,1,.013,29.675,29.406,29.406,0,0,1,29.293.013Z",
    transform: "translate(0 58.618) rotate(-88.093)",
    fill: "#ffb93e"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_1474",
    "data-name": "Group 1474",
    transform: "translate(3.582 3.882)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_422",
    "data-name": "Path 422",
    d: "M1260.768,1440.543a27.1,27.1,0,0,1-19.163-7.835,26.5,26.5,0,0,1,0-37.828,27.354,27.354,0,0,1,38.326,0,26.5,26.5,0,0,1,0,37.828A27.1,27.1,0,0,1,1260.768,1440.543Zm0-51.9a25.155,25.155,0,1,0,25.484,25.153A25.349,25.349,0,0,0,1260.768,1388.641Z",
    transform: "translate(-1233.667 -1387.045)",
    fill: "#ffa412"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_1475",
    "data-name": "Group 1475",
    transform: "translate(18.813 10.877)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_423",
    "data-name": "Path 423",
    d: "M1306.479,1441.18a4.359,4.359,0,0,0-.064-1.553,3.207,3.207,0,0,0-.665-1.29,6.139,6.139,0,0,0-1.33-1.159,16.411,16.411,0,0,0-2.062-1.14,42.877,42.877,0,0,1-3.808-2.065,13.454,13.454,0,0,1-2.847-2.287,7.816,7.816,0,0,1-1.682-2.787,8.741,8.741,0,0,1,.724-6.685,7.469,7.469,0,0,1,2.1-2.3,9.452,9.452,0,0,1,3.007-1.413,12.711,12.711,0,0,1,3.754-.427l.53-4.409,3.6.421-.537,4.47a11.316,11.316,0,0,1,3.384,1.42,8.685,8.685,0,0,1,2.436,2.291,8.554,8.554,0,0,1,1.351,3.073,11.016,11.016,0,0,1,.148,3.788l-6.494-.761a5.379,5.379,0,0,0-.668-3.828,3.839,3.839,0,0,0-2.83-1.574,4.932,4.932,0,0,0-1.775.075,3.313,3.313,0,0,0-1.294.621,3.04,3.04,0,0,0-.834,1.062,4.413,4.413,0,0,0-.4,1.4,4.032,4.032,0,0,0,.058,1.406,3.014,3.014,0,0,0,.638,1.235,6.172,6.172,0,0,0,1.342,1.16,20.934,20.934,0,0,0,2.143,1.223q2.082,1.059,3.768,2.113a13.6,13.6,0,0,1,2.833,2.306,8.29,8.29,0,0,1,.94,9.522,7.377,7.377,0,0,1-2.109,2.281,9.131,9.131,0,0,1-3.023,1.36,13.721,13.721,0,0,1-3.773.394l-.493,4.1-3.573-.419.49-4.079a15.324,15.324,0,0,1-3.51-1.226,9.616,9.616,0,0,1-2.875-2.144,8.471,8.471,0,0,1-1.8-3.188,10.214,10.214,0,0,1-.3-4.339l6.494.76a6.3,6.3,0,0,0,.122,2.49,4.107,4.107,0,0,0,.924,1.7,4.052,4.052,0,0,0,1.485,1.01,7.021,7.021,0,0,0,1.781.448,5.87,5.87,0,0,0,1.886-.05,3.9,3.9,0,0,0,1.427-.585,3.052,3.052,0,0,0,.944-1.028A3.674,3.674,0,0,0,1306.479,1441.18Z",
    transform: "translate(-1290.878 -1413.662)",
    fill: "#ffa412"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_1478",
    "data-name": "Group 1478",
    transform: "translate(412.396 531.603)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_436",
    "data-name": "Path 436",
    d: "M10.853,0A10.979,10.979,0,0,1,21.736,11.03,10.9,10.9,0,0,1,10.887,22.02,10.979,10.979,0,0,1,0,10.995,10.9,10.9,0,0,1,10.853,0Z",
    transform: "translate(0 21.718) rotate(-88.093)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_1477",
    "data-name": "Group 1477",
    transform: "translate(6.631 3.413)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_424",
    "data-name": "Path 424",
    d: "M1112.7,1255.439a1.67,1.67,0,0,0-.087-.59,1.234,1.234,0,0,0-.305-.465,2.37,2.37,0,0,0-.553-.39,6.25,6.25,0,0,0-.832-.354,16.418,16.418,0,0,1-1.534-.638,5.19,5.19,0,0,1-1.177-.76,3.006,3.006,0,0,1-.753-1,3.346,3.346,0,0,1,.008-2.576,2.849,2.849,0,0,1,.708-.96,3.608,3.608,0,0,1,1.089-.656,4.865,4.865,0,0,1,1.413-.31l.025-1.7,1.387.02-.025,1.725a4.342,4.342,0,0,1,1.346.409,3.344,3.344,0,0,1,1.021.778,3.292,3.292,0,0,1,.638,1.118,4.226,4.226,0,0,1,.208,1.438l-2.505-.036a2.065,2.065,0,0,0-.408-1.433,1.475,1.475,0,0,0-1.142-.489,1.888,1.888,0,0,0-.673.1,1.263,1.263,0,0,0-.468.287,1.161,1.161,0,0,0-.275.437,1.7,1.7,0,0,0-.095.547,1.551,1.551,0,0,0,.079.534,1.153,1.153,0,0,0,.293.445,2.375,2.375,0,0,0,.558.39,8.132,8.132,0,0,0,.866.382q.836.322,1.521.658a5.232,5.232,0,0,1,1.172.768,3.177,3.177,0,0,1,.74,3.592,2.81,2.81,0,0,1-.712.952,3.485,3.485,0,0,1-1.1.636,5.246,5.246,0,0,1-1.422.3l-.024,1.582-1.378-.02.023-1.573a5.885,5.885,0,0,1-1.387-.33,3.7,3.7,0,0,1-1.182-.7,3.259,3.259,0,0,1-.815-1.145,3.92,3.92,0,0,1-.288-1.642l2.505.036a2.413,2.413,0,0,0,.146.944,1.58,1.58,0,0,0,.42.61,1.562,1.562,0,0,0,.606.327,2.693,2.693,0,0,0,.7.1,2.251,2.251,0,0,0,.716-.093,1.48,1.48,0,0,0,.52-.279,1.159,1.159,0,0,0,.319-.429A1.4,1.4,0,0,0,1112.7,1255.439Z",
    transform: "translate(-1106.662 -1245.044)",
    fill: "#afcdfb"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_1480",
    "data-name": "Group 1480",
    transform: "translate(428.358 496.248)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_425",
    "data-name": "Path 425",
    d: "M1141.706,1113.18a15.876,15.876,0,1,1,15.874,15.669A15.772,15.772,0,0,1,1141.706,1113.18Z",
    transform: "translate(-1141.706 -1097.512)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_1479",
    "data-name": "Group 1479",
    transform: "translate(9.051 4.422)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_426",
    "data-name": "Path 426",
    d: "M1184.409,1129.313a2.4,2.4,0,0,0-.125-.849,1.777,1.777,0,0,0-.44-.671,3.4,3.4,0,0,0-.8-.561,9.031,9.031,0,0,0-1.2-.51,23.676,23.676,0,0,1-2.209-.919,7.46,7.46,0,0,1-1.695-1.095,4.325,4.325,0,0,1-1.084-1.436,4.816,4.816,0,0,1,.011-3.71,4.108,4.108,0,0,1,1.019-1.383,5.211,5.211,0,0,1,1.569-.945,7,7,0,0,1,2.036-.446l.036-2.45,2,.028-.037,2.484a6.266,6.266,0,0,1,1.94.589,4.805,4.805,0,0,1,1.469,1.12,4.737,4.737,0,0,1,.919,1.611,6.094,6.094,0,0,1,.3,2.072l-3.609-.052a2.974,2.974,0,0,0-.588-2.064,2.124,2.124,0,0,0-1.644-.7,2.72,2.72,0,0,0-.97.141,1.821,1.821,0,0,0-.674.414,1.669,1.669,0,0,0-.4.63,2.442,2.442,0,0,0-.137.788,2.227,2.227,0,0,0,.114.769,1.666,1.666,0,0,0,.421.642,3.423,3.423,0,0,0,.8.561,11.657,11.657,0,0,0,1.247.551q1.2.464,2.19.948a7.526,7.526,0,0,1,1.688,1.106,4.579,4.579,0,0,1,1.067,5.174,4.059,4.059,0,0,1-1.026,1.371,5.022,5.022,0,0,1-1.581.916,7.56,7.56,0,0,1-2.048.428l-.034,2.278-1.985-.029.033-2.267a8.469,8.469,0,0,1-2-.475,5.325,5.325,0,0,1-1.7-1.015,4.685,4.685,0,0,1-1.174-1.649,5.641,5.641,0,0,1-.415-2.365l3.609.052a3.474,3.474,0,0,0,.211,1.36,2.192,2.192,0,0,0,1.479,1.35,3.882,3.882,0,0,0,1,.146,3.242,3.242,0,0,0,1.032-.134,2.139,2.139,0,0,0,.749-.4,1.671,1.671,0,0,0,.459-.618A2.013,2.013,0,0,0,1184.409,1129.313Z",
    transform: "translate(-1175.705 -1114.34)",
    fill: "#afcdfb"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_1482",
    "data-name": "Group 1482",
    transform: "translate(382.315 450.712)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_429",
    "data-name": "Path 429",
    d: "M21.49.127A21.851,21.851,0,0,1,43.095,21.876,21.266,21.266,0,0,1,21.732,43.382,21.851,21.851,0,0,1,.127,21.633,21.266,21.266,0,0,1,21.49.127Z",
    transform: "translate(0 37.214) rotate(-60.344)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_1481",
    "data-name": "Group 1481",
    transform: "translate(20.273 13.827)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_427",
    "data-name": "Path 427",
    d: "M1056.806,997.31a3.285,3.285,0,0,0-.171-1.16,2.423,2.423,0,0,0-.6-.917,4.659,4.659,0,0,0-1.09-.767,12.392,12.392,0,0,0-1.637-.7,32.435,32.435,0,0,1-3.02-1.256,10.184,10.184,0,0,1-2.316-1.5,5.913,5.913,0,0,1-1.482-1.962,6.587,6.587,0,0,1,.015-5.071,5.611,5.611,0,0,1,1.393-1.889,7.106,7.106,0,0,1,2.145-1.292,9.559,9.559,0,0,1,2.783-.61l.049-3.348,2.731.039-.05,3.4a8.564,8.564,0,0,1,2.651.8,6.584,6.584,0,0,1,2.009,1.531,6.476,6.476,0,0,1,1.256,2.2,8.318,8.318,0,0,1,.411,2.831l-4.932-.071a4.065,4.065,0,0,0-.8-2.821,2.9,2.9,0,0,0-2.248-.963,3.711,3.711,0,0,0-1.326.193,2.492,2.492,0,0,0-.922.565,2.287,2.287,0,0,0-.542.861,3.32,3.32,0,0,0-.186,1.077,3.047,3.047,0,0,0,.155,1.051,2.282,2.282,0,0,0,.576.877,4.671,4.671,0,0,0,1.1.767,15.883,15.883,0,0,0,1.7.752q1.646.634,2.994,1.295a10.3,10.3,0,0,1,2.308,1.512,6.256,6.256,0,0,1,1.458,7.071,5.541,5.541,0,0,1-1.4,1.874,6.868,6.868,0,0,1-2.161,1.252,10.32,10.32,0,0,1-2.8.586l-.046,3.114-2.714-.039.046-3.1a11.562,11.562,0,0,1-2.73-.65,7.276,7.276,0,0,1-2.327-1.387,6.41,6.41,0,0,1-1.605-2.253,7.713,7.713,0,0,1-.567-3.232l4.932.071a4.748,4.748,0,0,0,.288,1.859,3.109,3.109,0,0,0,.827,1.2,3.071,3.071,0,0,0,1.194.643,5.289,5.289,0,0,0,1.371.2,4.427,4.427,0,0,0,1.411-.183,2.927,2.927,0,0,0,1.024-.549,2.3,2.3,0,0,0,.627-.844A2.765,2.765,0,0,0,1056.806,997.31Z",
    transform: "translate(-1044.909 -976.845)",
    fill: "#afcdfb"
  }))))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgPricing);
export default __webpack_public_path__ + "static/media/pricing.f85c0db40f9be99761e801c21abea1f4.svg";
export { ForwardRef as ReactComponent };